import { render, staticRenderFns } from "./LbaFulltextSearch.vue?vue&type=template&id=65a71924"
import script from "./LbaFulltextSearch.vue?vue&type=script&lang=js"
export * from "./LbaFulltextSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports